import { createApp, InjectionKey, Ref, ref } from "vue";
import App from "./App.vue";
import router from "./router";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";

const app = createApp(App);
const captchaKey: Ref<string> = ref(
    getEnvVariable.execute("VUE_APP_CAPTCHA_KEY")
);

// Define the injection key
export const successProcessKey: InjectionKey<{
    isVisibleSuccessMessage: Ref<boolean>;
    messageSuccess: Ref<string>;
    showSuccessModal: (message: string, callback?: () => void) => void;
    closeSuccessModal: () => void;
}> = Symbol();

const isVisibleSuccessMessage: Ref<boolean> = ref(false);
const messageSuccess: Ref<string> = ref("");
const callbackRedirect: Ref<() => void> = ref(() => undefined);
function showSuccessModal(message: string, callback?: () => void): void {
    callbackRedirect.value = callback ?? (() => undefined);
    isVisibleSuccessMessage.value = true;
    messageSuccess.value = message;
}
async function closeSuccessModal(): Promise<void> {
    isVisibleSuccessMessage.value = false;
    if (typeof callbackRedirect.value !== "undefined") {
        await callbackRedirect.value();
    }
}

function sleep(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export const spinnerProcessKey: InjectionKey<{
    isVisibleSpinner: Ref<boolean>;
    onSpinnerState: () => Promise<void>;
    offSpinnerState: () => Promise<void>;
}> = Symbol();

const isVisibleSpinner: Ref<boolean> = ref(false);

async function onSpinnerState(): Promise<void> {
    isVisibleSpinner.value = true;
}
async function offSpinnerState(): Promise<void> {
    await sleep(300);
    isVisibleSpinner.value = false;
}

export const currencyProcessKey: InjectionKey<{
    actualCurrency: Ref<string>;
    changeCurrency: () => Promise<void>;
}> = Symbol();

const actualCurrency: Ref<string> = ref("US");

async function changeCurrency(): Promise<void> {
    actualCurrency.value = actualCurrency.value == "US" ? "COP" : "US";
}

app.provide(successProcessKey, {
    isVisibleSuccessMessage: isVisibleSuccessMessage,
    messageSuccess: messageSuccess,
    showSuccessModal: showSuccessModal,
    closeSuccessModal: closeSuccessModal,
});
app.provide(spinnerProcessKey, {
    isVisibleSpinner: isVisibleSpinner,
    onSpinnerState: onSpinnerState,
    offSpinnerState: offSpinnerState,
});
app.provide(currencyProcessKey, {
    actualCurrency: actualCurrency,
    changeCurrency: changeCurrency,
});
app.provide("captchaKey", captchaKey);
app.use(router).mount("#app");
